export const ROUTES = {
  CONTACT: 'contact',
  HOME: '/',
  PROFILE: 'profile',
  PROJECTS: 'projects',
};
